import styled from "styled-components";
import { FontFamilyTypeEnum, COLORS } from "../../components/styled";

export const ProfilePageWrapper = styled.div`
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 16px;

  * {
    font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 0 12px;
  gap: 8px;
`;

export const AvatarWrapper = styled.div<{ $teamColor?: string }>`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 3px solid ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  overflow: hidden;
  background: ${COLORS.GREY_MAIN};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AvatarInitials = styled.span`
  font-size: 44px;
  font-weight: 700;
  color: ${COLORS.GREY_TEXT};
`;

export const EditIconButton = styled.button<{ $teamColor?: string }>`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid ${COLORS.WHITE};
  background: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.9;
  }
`;

export const ProfileName = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${COLORS.BLACK_MAIN};
  text-align: center;
`;

export const SeatInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
`;

export const SeasonTicketBadge = styled.div<{ $teamColor?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 6px 14px;
  border-radius: 20px;
  background: ${(p) => (p.$teamColor ? `${p.$teamColor}18` : "#f0f5ff")};
  border: 1.5px solid ${(p) => (p.$teamColor || "#3b82f6")};
`;

export const SeasonTicketBadgeLogo = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

export const SeasonTicketBadgeText = styled.span<{ $teamColor?: string }>`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${(p) => (p.$teamColor || "#3b82f6")};
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 16px;

  @media (min-width: 480px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const StatCard = styled.div`
  background: #f9fafb;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #e5e7eb;
`;

export const StatLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
`;

export const StatValue = styled.div<{ $teamColor?: string }>`
  font-size: 24px;
  font-weight: 700;
  color: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 2px;
`;

export const SectionTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.BLACK_MAIN};
`;

export const SeeAllLink = styled.button<{ $teamColor?: string }>`
  font-size: 14px;
  font-weight: 600;
  color: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const MomentsScrollStrip = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-bottom: 28px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }
`;

export const MomentImageTile = styled.div`
  flex-shrink: 0;
  width: 216px;
  height: 216px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: #f3f4f6;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &:hover {
    border-color: #9ca3af;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`;

export const MomentsScroll = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-bottom: 28px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 3px;
  }
`;

export const MomentCard = styled.div`
  flex-shrink: 0;
  width: 180px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background: ${COLORS.WHITE};
`;

export const MomentCardImage = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4/3;
  background: #f3f4f6;
  overflow: hidden;
`;

export const MomentImageCount = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: ${COLORS.WHITE};
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
`;

export const MomentCardContent = styled.div`
  padding: 12px;
`;

export const MomentCardTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${COLORS.BLACK_MAIN};
  margin-bottom: 4px;
`;

export const MomentCardDate = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 10px;
`;

export const ViewImagesButton = styled.button<{ $teamColor?: string }>`
  width: 100%;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  border-radius: 8px;
  border: none;
  background: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  color: ${COLORS.WHITE};
  cursor: pointer;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const PreviewModalActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  flex-shrink: 0;
`;

export const PreviewModalButton = styled.button<{ $secondary?: boolean; $teamColor?: string }>`
  padding: 10px 32px;
  min-width: 160px;
  font-size: 14px;
  font-weight: 600;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  border-radius: 6px;
  border: 2px solid ${({ $secondary, $teamColor }) => ($teamColor || COLORS.BLUE_MAIN)};
  background: ${({ $secondary, $teamColor }) => ($secondary ? "transparent" : ($teamColor || COLORS.BLUE_MAIN))};
  color: ${({ $secondary, $teamColor }) => ($secondary ? ($teamColor || COLORS.BLUE_MAIN) : COLORS.WHITE)};
  cursor: pointer;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const PreviewModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 24px;
`;

export const PreviewImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0;
  width: 100%;
  max-height: calc(100vh - 180px);
`;

export const GameHistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GameHistoryItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  cursor: pointer;

  &:hover {
    background: #f3f4f6;
  }
`;

export const GameHistoryIcon = styled.div<{ $teamColor?: string }>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  flex-shrink: 0;
  opacity: 0.9;
`;

export const GameHistoryContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const GameHistoryTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.BLACK_MAIN};
`;

export const GameHistorySubtitle = styled.div`
  font-size: 13px;
  color: #6b7280;
  margin-top: 2px;
`;

export const GameHistoryChevron = styled.span`
  color: #9ca3af;
  font-size: 14px;
  flex-shrink: 0;
`;

export const EmptyStateCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 24px;
  background: ${COLORS.WHITE};
  text-align: left;
`;

export const ProfileBottomButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 32px;
  padding: 24px 0 16px;
  border-top: 1px solid #e5e7eb;
`;

export const GameActionLink = styled.button<{ $teamColor?: string }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-align: left;
  font-size: 12px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-weight: 600;
  color: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  margin-top: 4px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;

export const ShareModalSection = styled.div`
  margin-bottom: 20px;
`;

export const ShareModalLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  color: #374151;
  margin-bottom: 8px;
`;

export const ShareModalDescription = styled.p`
  font-size: 13px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  color: #6b7280;
  line-height: 1.5;
  margin: 0 0 16px;
`;

export const ShareUrlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ShareUrlText = styled.div`
  flex: 1;
  font-size: 13px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  color: #374151;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const ShareCopyButton = styled.button<{ $teamColor?: string }>`
  flex-shrink: 0;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 600;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  border-radius: 8px;
  border: 1px solid ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  background: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  color: ${COLORS.WHITE};
  cursor: pointer;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ShareEmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

export const ShareEmailInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  font-size: 13px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  outline: none;
  min-width: 0;

  &:focus {
    border-color: #9ca3af;
  }
`;

export const ShareRemoveButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  color: #9ca3af;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;

  &:hover {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
  }
`;

export const ShareAddButton = styled.button<{ $teamColor?: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  background: none;
  border: 1px dashed ${({ $teamColor }) => $teamColor || COLORS.BLUE_MAIN};
  border-radius: 8px;
  cursor: pointer;
  margin-top: 2px;

  &:hover {
    background: #f9fafb;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ShareDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  font-size: 12px;
  font-weight: 500;
  color: #9ca3af;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e5e7eb;
  }
`;

export const SharedWithList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;

export const SharedWithBadge = styled.span`
  font-size: 11px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  font-weight: 500;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 12px;
  padding: 2px 8px;
`;

export const ProfileBottomButton = styled.button<{ $teamColor?: string; $danger?: boolean; $secondary?: boolean }>`
  flex: 1;
  min-width: 120px;
  max-width: 180px;
  padding: 6px 24px 6px;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  line-height: 16px;
  font-family: ${FontFamilyTypeEnum.MONTSERRAT}, sans-serif;
  border-radius: 12px;
  border: 1px solid ${({ $teamColor, $danger }) => ($danger ? "#dc2626" : ($teamColor || COLORS.BLUE_MAIN))};
  background-color: ${({ $secondary, $teamColor, $danger }) => ($secondary ? "transparent" : ($danger ? "#dc2626" : ($teamColor || COLORS.BLUE_MAIN)))};
  color: ${({ $secondary, $teamColor, $danger }) => ($secondary ? ($teamColor || COLORS.BLUE_MAIN) : COLORS.WHITE)};
  cursor: pointer;
  margin: 0;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;
